import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { MdOutlineLocationOn, MdOutlineBathtub } from 'react-icons/md';
import { FaToilet } from 'react-icons/fa';
import { BiBed, BiArea } from 'react-icons/bi';
import { getPropertyIDAction } from "../../redux/actions/propertyActions";
import { baseUrl } from "../../shared/baseUrl";
import { Carousel } from 'react-responsive-carousel';
import ImagePreviewModal from '../../components/ImagePreviewModal';

const PropertyDetails = () => {
  const dispatch = useDispatch()
  const propertyId = useParams()

  const [previewModal, setPreviewModal] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(1)

  const getPropertyID = useSelector(state => state.getPropertyID)
  const { data } = getPropertyID

  useEffect(() => {
    dispatch(getPropertyIDAction(propertyId.id))
  }, [dispatch, propertyId])

  // --- Number to Currency Format
  const formatToCurrency = Intl.NumberFormat('en-US')

  // --- Whatsapp Number -- //
  const whatsappNo = data?.property?.createdBy?.phoneNumber

  return (
    <div id="property-details">
      <Header />
      <main>
        <section className="pd-area">
          <div className="pd-area_wrap container">
            <div>
              <div className="pd-title">
                <h1>{data?.property?.title}</h1>
                <div className="pd-title_location">
                  <MdOutlineLocationOn size={20} />
                  <p>{data?.property?.address}, {data?.property?.lga}, {data?.property?.state}</p>
                </div>
              </div>
              <div className="pd-accomodate">
                {data?.property?.bedrooms &&
                  <div className="pd-accomodate_item">
                    <BiBed size={30} />
                    <p>{data?.property?.bedrooms} Bedroom</p>
                  </div>
                }
                {data?.property?.bath &&
                  <div className="pd-accomodate_item">
                    <MdOutlineBathtub size={30} />
                    <p>{data?.property?.bath} Bath</p>
                  </div>
                }
                {data?.property?.toilet && 
                  <div className="pd-accomodate_item">
                    <FaToilet size={30} />
                    <p>{data?.property?.toilet} Toilet</p>
                  </div>
                }
                {data?.property?.square && 
                  <div className="pd-accomodate_item">
                    <BiArea size={30} />
                    <p>{data?.property?.square} sqft</p>
                  </div>
                } 
              </div>
            </div>
            <div className="pd-price">
              <h2>₦{formatToCurrency.format(data?.property?.price)}</h2>
              <a href={`tel:${data?.property?.createdBy?.phoneNumber}`}>{data?.property?.createdBy?.phoneNumber}</a>
            </div>
          </div>
        </section>

        <section className="prop-swiper container">
          <Carousel>
            {data?.property?.images?.map((item, index) => 
              <div 
                key={index} 
                className="swipe-img_wrap"
                onClick={() => {
                  setPreviewModal(true);
                  setCurrentSlide(index + 1);
                }}>
                <img src={`${baseUrl}/${item}`} alt={`Slide ${index}`} />
              </div>
            )}
          </Carousel>
        </section>

        <ImagePreviewModal 
          images={data?.property?.images}
          previewModal={previewModal}
          setPreviewModal={setPreviewModal}
          currentSlide={currentSlide}
          setCurrentSlide={setCurrentSlide}
          baseUrl={baseUrl}
        />

        <section className="description container">
          <h2>Description</h2>
          <p>{data?.property?.description}</p>
        </section>
        <section className="agent-details container">
          <h2>Agent Details</h2>
          <div className="agent-detail_grid">
            <p>Full Name:</p>
            <p>{data?.property?.createdBy?.firstname} {data?.property?.createdBy?.lastname}</p>
            <p>Email:</p>
            <p>{data?.property?.createdBy?.email}</p>
            <p>Username:</p>
            <p>@{data?.property?.createdBy?.username}</p>
            <p>Whatsapp:</p>
            <a 
              href={`https://wa.me/+234${whatsappNo?.slice(whatsappNo?.length - 10)}`} 
              target="_blank" 
              rel="noopener noreferrer">
              +234{whatsappNo?.slice(whatsappNo?.length - 10)}
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default PropertyDetails;